import React from 'react'
import { styled, Grid as GridBase } from '@mui/material'

export const GridContainer = styled(props => <GridBase {...props} container />)``

export const GridItem = styled(props => <GridBase {...props} item />)`
  &.MuiGrid-item {
    display: flex;
    flex-direction: ${props => props.flexDirection || 'column'};
    margin: ${props => props.margin || '0'};
    padding: ${props => props.padding || '0'};
  }
`

export const DescriptionTitle = styled('div')`
  color: ${props => props.theme.palette.background.black1};
  font-size: 27px;
  font-style: normal;
  font-weight: 700;
  line-height: 31px;
  padding-top: 15px;
  ${props => props.theme.breakpoints.down('md')} {
    font-size: 22px;
    line-height: 26px;
  }
`

export const DescriptionText = styled(DescriptionTitle)`
  color: ${props => props.theme.palette.brand.black1};
  font-size: 16px;
  font-style: normal;
  font-weight: 400;
  line-height: 21px;
  padding: 15px 0 24px;
  text-wrap: balance;
  ${props => props.theme.breakpoints.down('lg')} {
    text-wrap: pretty;
  }
`

export const HighLighted = styled('span')`
  font-weight: 700;
  line-height: 21px;
  text-align: left;
`

export const NotAllowedRootArea = styled(props => <GridContainer {...props} />)``

export const ErrorContainer = styled(GridBase)`
  border: 1px solid ${props => props.theme.palette.brand.gray2};
  height: 243px;
  margin: 30px 0 0;
  width: 100%;
`

export const ErrorMessageContainer = styled('div')`
  align-items: center;
  display: flex;
  flex-direction: row;
  justify-content: center;
  max-width: 600px;
`

export const AlertIcon = styled('img')`
  height: 48px;
  margin: 0 auto;
  width: 48px;
  ${props => props.theme.breakpoints.down('md')} {
    padding: 0 0 0 15px;
  }
`
